module.exports = __webpack_public_path__ + "img/kluay.187a28de.png";